import PropTypes from 'prop-types';

function EditorActions({ onSave, onClear, onExportSVG, onCopy, hasContent }) {
  return (
    <div className="editor-actions" style={{ display: 'flex', gap: 'var(--space-8)', flexWrap: 'wrap' }}>
      <button
        className="btn btn--primary btn--sm"
        onClick={onSave}
        disabled={!hasContent}
        title="Save current diagram (Ctrl+S)"
      >
        <span className="btn-icon">💾</span>
        <span className="btn-text">Save</span>
      </button>
      <button
        className="btn btn--secondary btn--sm"
        onClick={onClear}
        title="Clear editor (Ctrl+N)"
      >
        <span className="btn-icon">🗑️</span>
        <span className="btn-text">Clear</span>
      </button>
      <button
        className="btn btn--secondary btn--sm"
        onClick={onExportSVG}
        disabled={!hasContent}
        title="Export as SVG"
      >
        <span className="btn-icon">📥</span>
        <span className="btn-text">Export</span>
      </button>
      <button
        className="btn btn--secondary btn--sm"
        onClick={onCopy}
        disabled={!hasContent}
        title="Copy code to clipboard"
      >
        <span className="btn-icon">📋</span>
        <span className="btn-text">Copy</span>
      </button>
    </div>
  );
}

EditorActions.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onExportSVG: PropTypes.func.isRequired,
  onCopy: PropTypes.func.isRequired,
  hasContent: PropTypes.bool.isRequired
};

export default EditorActions;
